const _actions = [
  {
    displayName: "Signup User with Email",
    name: "auth.signUpWithEmailandPassword",
    props: [
      {
        name: "email",
        displayName: "Email",
        editor: "dynamic",
        editorParams: { type: "Text", default: ["", {}, ""] },
      },
      {
        name: "password",
        displayName: "Password",
        editor: "dynamic",
        editorParams: { type: "Text", default: ["", {}, ""] },
      },
      {
        name: "confirm",
        displayName: "Confirm Password",
        editor: "dynamic",
        editorParams: { type: "Text", default: ["", {}, ""] },
      },
    ],
    return: [
      { name: "user", type: "user", list: false },
      { name: "error", type: "Text", list: false },
    ],
    type: "User",
    async: true,
    frontend: true,
    backend: false,
  },
  {
    displayName: "Log User In With Email",
    props: [
      {
        name: "email",
        displayName: "Email",
        editor: "dynamic",
        editorParams: { type: "Text", default: ["", {}, ""] },
      },
      {
        name: "password",
        displayName: "Password",
        editor: "dynamic",
        editorParams: { type: "Text", default: ["", {}, ""] },
      },
    ],
    name: "auth.loginWithEmailandPassword",
    return: [
      { name: "user", type: "user", list: false },
      { name: "error", type: "Text", list: false },
    ],
    type: "User",
    async: true,
  },
  {
    displayName: "Log User In With API",
    props: [
      {
        name: "api",
        displayName: "API",
        editor: "oauth",
      },
    ],
    name: "auth.loginWithOAuth",
    return: [
      { name: "user", type: "user", list: false },
      { name: "error", type: "Text", list: false },
    ],
    type: "User",
    async: true,
  },
  {
    displayName: "Send Login Magic Link to User",
    props: [
      {
        name: "email",
        displayName: "Email",
        editor: "dynamic",
        editorParams: { type: "Text", default: ["", {}, ""] },
      },
    ],
    name: "auth.sendMagicLink",
    return: [{ name: "error", type: "True/False", list: false }],
    type: "User",
    async: true,
  },
  {
    displayName: "Send Password Reset Email",
    props: [
      {
        name: "email",
        displayName: "Users Email",
        editor: "dynamic",
        editorParams: { type: "Text", default: ["", {}, ""] },
      },
      {
        name: "subject",
        displayName: "Email Subject",
        editor: "dynamic",
        editorParams: { type: "Text", default: ["Password Reset Request"] },
      },
      {
        name: "body",
        displayName: "Email Body",
        editor: "dynamic",
        editorParams: {
          type: "Text",
          default: ["Here is the link to Reset yor password"],
        },
      },
    ],
    name: "auth.sendResetEmail",
    returnType: "user",
    returnList: false,
    type: "User",
    async: true,
  },
  {
    displayName: "Reset User Password",
    props: [
      {
        name: "newPassword",
        displayName: "New Password",
        editor: "dynamic",
        editorParams: { type: "Text", default: ["", {}, ""] },
      },
    ],
    name: "auth.confirmPasswordReset",
    returnType: "user",
    returnList: false,
    type: "User",
    async: true,
  },
  {
    displayName: "Sign user out",
    props: [],
    name: "auth.logout",
    type: "User",
    async: true,
    frontend: true,
    backend: false,
  },
  {
    displayName: "Sign out all sessions for user",
    props: [
      {
        name: "user",
        displayName: "user",
        editor: "dynamic",
        editorParams: { type: "user", default: ["", {}, ""] },
      },
    ],
    name: "auth.logoutAllSessions",
    type: "User",
    async: true,
    frontend: true,
    backend: false,
  },
  {
    displayName: "Navigate to Page",
    props: [{ name: "page", displayName: "Page", editor: "pages" }],
    name: "navigate",
    type: "Navigation",
    frontend: true,
    backend: false,
  },
  {
    name: "Open External URL",
    props: [
      { name: "url", displayName: "URL", editor: "dynamicText", default: [""] },
    ],
    name: "app.open",
    type: "Navigation",
    frontend: true,
    backend: false,
  },
  {
    displayName: "Delete a Row",
    props: [
      { name: "_table", displayName: "Table", editor: "table" },
      {
        name: "row",
        displayName: "Row",
        editor: "dynamic",
        editorParams: { type: "_table", list: false, default: [{}] },
      },
    ],
    name: "data.delete",
    type: "Data",
    async: true,
    frontend: true,
    backend: true,
  },
  {
    displayName: "Update a Row",
    props: [
      { name: "_table", displayName: "Table", editor: "table" },
      {
        name: "row",
        displayName: "Row",
        editor: "dynamic",
        editorParams: { type: "_table", list: false, default: [{}] },
      },
      {
        name: "data",
        displayName: "Set Data",
        editor: "setData",
        editorParams: { type: "_table", default: {} },
      },
    ],
    return: [
      { name: "row", type: "_table", list: false },
      { name: "error", type: "Text", list: false },
    ],
    name: "data.update",
    type: "Data",
    async: true,
    frontend: true,
    backend: true,
  },
  {
    displayName: "Create a new row",
    props: [
      { name: "_table", displayName: "Table", editor: "table" },
      {
        name: "data",
        displayName: "Set Data",
        editor: "setData",
        editorParams: { type: "_table", default: {} },
      },
    ],
    name: "data.add",
    type: "Data",
    async: true,
    return: [
      { name: "row", type: "_table", list: false },
      { name: "error", type: "Text", list: false },
    ],
    frontend: true,
    backend: true,
  },
  {
    displayName: "Log",
    props: [
      {
        name: "value",
        displayName: "Value",
        editor: "dynamic",
        editorParams: { type: "", lsit: false },
        required: true,
      },
    ],
    name: "console.log",
    type: "Data",
    frontend: true,
    backend: true,
  },
  {
    displayName: "Load Data from Database",
    props: [
      {
        name: "_table",
        displayName: "Data Type for List",
        editor: "table",
        editorParams: {},
        help: "",
      },
      {
        name: "_fields",
        displayName: "Fields for Data",
        editor: "fieldSelect",
        editorParams: { default: null, type: "_table" },
        help: "Selecting only the fields you need will make your app faster",
      },
      {
        name: "_filters",
        displayName: "Filters",
        editor: "dataFilters",
        editorParams: { default: null, type: "_table" },
        help: "",
      },
    ],
    name: "data.get",
    type: "Data",
    async: true,
    return: [
      { name: "row", type: "_table", list: true },
      { name: "error", type: "Text", list: false },
    ],
    frontend: false,
    backend: true,
  },
  {
    displayName: "Send Email",
    props: [
      {
        name: "to",
        displayName: "To",
        editor: "dynamic",
        editorParams: { type: "Text", default: [""] },
      },
      {
        name: "from",
        displayName: "From",
        editor: "dynamic",
        editorParams: { type: "Text", list: false, default: [""] },
      },
      {
        name: "subject",
        displayName: "Subject",
        editor: "dynamic",
        editorParams: { type: "Text", list: false, default: [""] },
      },
      {
        name: "body",
        displayName: "Body",
        editor: "dynamic",
        editorParams: { type: "Text", list: false, default: [""] },
      },
    ],
    name: "proxy.sendEmail",
    type: "Communication",
    frontend: false,
    backend: true,
  },
  {
    displayName: "Make API Request",
    props: [
      {
        name: "api",
        displayName: "API",
        editor: "apis",
      },
    ],
    async: true,
    name: "proxy.triggerAPI",
    type: "Connections",
    frontend: true,
    backend: true,
    return: [
      { name: "data", type: "api.type", list: "api.list" },
      { name: "error", type: "Text", list: false },
    ],
  },
  {
    displayName: "Trigger Webhook",
    props: [
      {
        name: "webhook",
        displayName: "Webhook",
        editor: "webhooks",
      },
    ],
    name: "proxy.triggerWebhook",
    type: "Connections",
    frontend: true,
    backend: false,
  },
  {
    displayName: "Get Geographical Location",
    props: [],
    type: "Geography",
    asyn: true,
    frontend: true,
    backend: false,
    name: "app.geolocation",
    return: [
      { name: "location", type: "Location", list: false },
      { name: "error", type: "Text", list: false },
    ],
  },
  {
    displayName: "IF / Else",

    type: "Opperations",
    frontend: true,
    backend: false,
    children: [
      {
        name: "if",
        displayName: "IF",
        props: [
          {
            name: "value",
            displayName: "value",
            editor: "dynamic",
            editorParams: { type: "True/False", list: false },
          },
        ],
      },
      {
        name: "else",
        displayName: "else",
        props: [],
      },
    ],
  },
  {
    displayName: "Stop Workflow",
    props: [],
    name: "return",
    type: "Opperations",
    frontend: true,
    backend: true,
  },
];

export default _actions;
const getUnique = (array) => {
  const _arr = [];
  array.forEach((x) => {
    if (!_arr.includes(x)) {
      _arr.push(x);
    }
  });
  return _arr;
};
export const _types = getUnique(_actions.map((x) => x.type));
